import { useInvestmentTransactionContext } from "../../contexts/VpsTransaction";

import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";

import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { numberWithCommas } from "../../utils/customFunction";

export default function InvestWithdrawal() {
  const {
    fields,
    handleCustomCheckboxChange,
    errors,
    typeVPS,
    amount,
    setAmount,
    subFundsBlocks,
    customStyles,
    navLoading,
    viewMode,
    handleSubFundAccountChange,
    handleChangeAllocation,
    currentSubFundsBlock,
    renderRange,
    setTypeVPS,
    setIndexedError,
    totalAmount,
    totalUnits,
    setUnits,
    units,
    noNav,
    handleManualWithdrawalAmount,
    handleManualWithdrawalUnits,
  } = useInvestmentTransactionContext();

  if (viewMode === "view" && fields.txnr_type === "changeofallocation")
    return <></>;
  if (viewMode === "changeofallocation") return <></>;

  const handleViewAmount = () => {
    let totalAmount: any = 0;
    subFundsBlocks?.map((ele) => {
      ele?.subFunds?.map((ele1) => {
        let temp =
          parseFloat(
            (
              parseFloat(parseFloat(ele1?.holding).toFixed(4)) * ele1?.nav
            ).toFixed(4),
          ) || 0;
        totalAmount += temp;
      });
    });
    return totalAmount ? totalAmount : 0;
  };

  return (
    <>
      <Row>
        {fields.amc_code && fields.folio_no ? (
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  <div className="d-flex justify-content-between align-items-center">
                    Systematic investment{" "}
                    {errors["units_0"] && (
                      <span className="text-danger">{errors["units_0"]}</span>
                    )}
                    {noNav && (
                      <span className="text-danger">
                        Please select sale date where nav exists to make amount
                        field editable
                      </span>
                    )}
                    {viewMode === "withdrawal" && (
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={
                              amount > 0 &&
                              units > 0 &&
                              !noNav &&
                              (parseFloat(amount).toFixed(4) ===
                                parseFloat(totalAmount).toFixed(4) ||
                                parseFloat(units).toFixed(4) ===
                                  parseFloat(totalUnits).toFixed(4))
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                setAmount(totalAmount);
                                setUnits(totalUnits);
                              } else {
                                setAmount(0);
                                setUnits(0);
                              }
                            }}
                          />
                          <span className="form-check-sign" />
                          All Amount
                        </Label>
                      </FormGroup>
                    )}
                  </div>
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <div className="form-group">
                      <label>Allocation Scheme</label>
                      <div>
                        <div>
                          <Select
                            value={{ label: typeVPS, value: typeVPS }}
                            label={"Select"}
                            isDisabled={true}
                            onChange={(e) => {
                              setTypeVPS(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            styles={customStyles}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col>
                    <div className="form-group">
                      <label>
                        {viewMode === "withdrawal" ||
                        fields.txnr_type === "withdrawal"
                          ? "Withdrawal "
                          : ""}
                        Amount
                      </label>
                      <div>
                        <NumberFormat
                          thousandSeparator={true}
                          value={amount}
                          placeholder="Enter Amount to Invest"
                          className={`form-control ${
                            errors.withdrawal ? "border-danger" : ""
                          }`}
                          disabled={viewMode !== "withdrawal"}
                          decimalScale={4}
                          onValueChange={(values: any) => {
                            const { value } = values;
                            const amount = parseFloat(
                              parseFloat(value || "0.00").toFixed(4),
                            );

                            setAmount(amount);
                          }}
                        />
                        {errors.withdrawal && (
                          <small className="text-danger d-block mt-1">
                            {errors.withdrawal}
                          </small>
                        )}
                      </div>
                    </div>
                  </Col>

                  {viewMode === "withdrawal" && (
                    <Col>
                      <div className="form-group">
                        <label>Units</label>
                        <div>
                          <NumberFormat
                            thousandSeparator={true}
                            value={units}
                            decimalScale={4}
                            placeholder="Enter Units to Invest"
                            className={`form-control`}
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>

                {subFundsBlocks.map((block, blockIndex) => {
                  return (
                    <div
                      key={block.id || blockIndex}
                      style={{
                        marginBottom: "15px",
                      }}
                    >
                      <Row>
                        <Col>
                          <div className="form-group">
                            <label>Fund</label>
                            <div>
                              <Select
                                isDisabled={true}
                                value={block.selectedParentFund}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col>
                          <div className="form-group">
                            <label>Current Investment</label>
                            <div style={{ position: "relative" }}>
                              <NumberFormat
                                thousandSeparator={true}
                                value={block?.total_holding || 0}
                                className={`form-control pr-5`}
                                disabled
                                decimalScale={4}
                                allowNegative={false}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col>
                          <div className="form-group">
                            <label>
                              {viewMode === "withdrawal" ||
                              fields.txnr_type === "withdrawal"
                                ? ""
                                : "Investment"}{" "}
                              Amount
                            </label>
                            <div style={{ position: "relative" }}>
                              <NumberFormat
                                thousandSeparator={true}
                                value={
                                  viewMode === "view"
                                    ? handleViewAmount()
                                    : viewMode === "withdrawal" ||
                                        fields.txnr_type === "withdrawal"
                                      ? parseFloat(totalAmount)?.toFixed(2)
                                      : block?.total_amount
                                }
                                className={`form-control pr-5`}
                                disabled
                                decimalScale={4}
                                allowNegative={false}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {!navLoading && (block?.fund || block?.fund_code) && (
                        <>
                          <Row className="mt-3">
                            <Col>
                              <strong>Fund Name</strong>
                            </Col>
                            <Col>
                              <strong>Account</strong>
                            </Col>
                            <Col>
                              <strong>Current Holding</strong>
                            </Col>

                            <Col>
                              <strong>Allocation %</strong>
                            </Col>

                            <Col>
                              <strong>
                                {viewMode === "withdrawal"
                                  ? "Withdrawal Amount"
                                  : "Amount"}
                              </strong>
                            </Col>

                            <Col>
                              <strong>NAV</strong>
                            </Col>

                            <Col>
                              <strong>
                                {viewMode === "withdrawal"
                                  ? "Withdrawal Units"
                                  : "Units"}
                              </strong>
                            </Col>
                          </Row>

                          {block?.subFunds?.map((ele: any, fundIndex) => {
                            const holdingUnits = parseFloat(
                              parseFloat(ele?.holding).toFixed(4) || "0",
                            );
                            const withdrawalUnits = parseFloat(
                              parseFloat(ele?.units).toFixed(4) || "0",
                            );
                            const nav = parseFloat(ele?.nav) || 0;
                            const maxAmount = parseFloat(
                              (holdingUnits * nav).toFixed(4),
                            );

                            const isWithdrawalExceeded =
                              viewMode === "withdrawal" &&
                              withdrawalUnits > holdingUnits;

                            const isAmountExceeded =
                              viewMode === "withdrawal" &&
                              parseFloat(ele?.amount || "0") > maxAmount;

                            return (
                              <Row
                                style={{
                                  alignItems:
                                    typeVPS === "Customized Allocation Scheme"
                                      ? "center"
                                      : "",
                                }}
                                key={fundIndex}
                                className="mt-2"
                              >
                                <Col>
                                  <div>
                                    <h4
                                      className="font-weight-bold"
                                      style={{ margin: 0 }}
                                    >
                                      {ele?.name}
                                    </h4>
                                  </div>
                                </Col>

                                <Col>
                                  <div className="form-group">
                                    <Select
                                      options={ele?.accounts || []}
                                      value={ele?.selected_account}
                                      isDisabled={viewMode === "view"}
                                      onChange={(selected) =>
                                        handleSubFundAccountChange(
                                          block.id,
                                          fundIndex,
                                          selected,
                                        )
                                      }
                                      placeholder="Select Account"
                                      isClearable
                                      isSearchable
                                      className={
                                        errors[`${ele.fund_code}:account`]
                                          ? "border-danger text-danger"
                                          : ""
                                      }
                                      styles={customStyles}
                                    />
                                  </div>
                                  {errors[`${ele.fund_code}:account`] && (
                                    <span className="text-danger">
                                      {errors[`${ele.fund_code}:account`]}
                                    </span>
                                  )}
                                </Col>

                                <Col>
                                  <div className="d-flex flex-column pt-2 pb-2 text-md">
                                    <h5 className="mr-0 mb-0">
                                      Units:{" "}
                                      <span className="font-weight-bold">
                                        {numberWithCommas(
                                          parseFloat(ele?.holding).toFixed(4) ||
                                            "0",
                                        )}
                                      </span>
                                    </h5>
                                    <h5 className="">
                                      Amount:{" "}
                                      <span className="font-weight-bold">
                                        {numberWithCommas(
                                          parseFloat(
                                            (
                                              parseFloat(
                                                parseFloat(
                                                  ele?.holding,
                                                ).toFixed(4),
                                              ) * ele?.nav
                                            ).toFixed(4),
                                          ) || "0",
                                        )}
                                      </span>
                                    </h5>
                                  </div>
                                </Col>

                                <Col>
                                  <div
                                    style={{
                                      marginBottom:
                                        typeVPS ===
                                        "Customized Allocation Scheme"
                                          ? "36px"
                                          : "",
                                    }}
                                    className="form-group"
                                  >
                                    <div style={{ position: "relative" }}>
                                      {typeVPS ===
                                      "Customized Allocation Scheme" ? (
                                        <>
                                          <FormGroup check>
                                            <Label
                                              style={{ bottom: "12px" }}
                                              check
                                            >
                                              <Input
                                                type="checkbox"
                                                disabled
                                                checked={
                                                  parseFloat(
                                                    ele?.proportion,
                                                  ) === 100
                                                }
                                                onChange={(e) => {
                                                  handleCustomCheckboxChange(
                                                    block.id,
                                                    fundIndex,
                                                    e.target.checked,
                                                  );
                                                }}
                                              />
                                              <span className="form-check-sign" />
                                            </Label>
                                          </FormGroup>
                                          <NumberFormat
                                            value={ele?.proportion}
                                            className={`form-control pr-5 ${
                                              errors[fundIndex]
                                                ? "border border-danger text-danger"
                                                : ""
                                            }`}
                                            disabled={
                                              (viewMode as string) !==
                                              "changeofallocation"
                                            }
                                            decimalScale={2}
                                            allowNegative={false}
                                          />
                                        </>
                                      ) : (
                                        <NumberFormat
                                          value={ele?.proportion}
                                          className={`form-control pr-5 ${
                                            errors[fundIndex]
                                              ? "border border-danger text-danger"
                                              : ""
                                          }`}
                                          disabled={
                                            (viewMode as string) !==
                                              "changeofallocation" ||
                                            !ele?.counter_fund.value
                                          }
                                          onValueChange={(values) => {
                                            const { value } = values;

                                            if (!ele?.counter_fund?.value)
                                              return;
                                            if (!ele?.nav) {
                                              setIndexedError(
                                                `fund_nav:${fundIndex}`,
                                                "Fund Nav is zero",
                                              );
                                              return;
                                            }

                                            const counterIndex =
                                              currentSubFundsBlock[0].subFunds.findIndex(
                                                (item) =>
                                                  item.fund_code ===
                                                  ele?.counter_fund?.value,
                                              );

                                            const range = String(
                                              renderRange(ele?.type_VPS),
                                            )
                                              ?.replace("%", "")
                                              .split("-");
                                            const numVal = parseFloat(value);
                                            if (numVal <= parseFloat(range[1]))
                                              handleChangeAllocation(
                                                block.id,
                                                fundIndex,
                                                numVal || 0,
                                                range,
                                                counterIndex,
                                              );
                                          }}
                                        />
                                      )}
                                      <span
                                        className={`input-group-text ${
                                          errors[fundIndex] ? "text-danger" : ""
                                        }`}
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top:
                                            typeVPS ===
                                            "Customized Allocation Scheme"
                                              ? "66%"
                                              : "51%",
                                          transform: "translateY(-50%)",
                                          background: "transparent",
                                          border: "none",
                                          pointerEvents: "none",
                                        }}
                                      >
                                        %
                                      </span>
                                    </div>
                                    {errors[fundIndex] && (
                                      <small className="text-danger">
                                        {errors[fundIndex]}
                                      </small>
                                    )}
                                  </div>
                                </Col>

                                {/* AMOUNT COLUMN — editable in withdrawal mode */}
                                <Col>
                                  <div className="form-group">
                                    <NumberFormat
                                      thousandSeparator={true}
                                      value={ele?.amount || "0"}
                                      // Editable only in withdrawal mode
                                      disabled={viewMode !== "withdrawal"}
                                      className={`form-control ${
                                        isAmountExceeded
                                          ? "border-danger text-danger"
                                          : viewMode === "withdrawal"
                                            ? "border-primary"
                                            : ""
                                      }`}
                                      decimalScale={4}
                                      allowNegative={false}
                                      onValueChange={(values) => {
                                        if (viewMode === "withdrawal") {
                                          handleManualWithdrawalAmount(
                                            block.id,
                                            fundIndex,
                                            parseFloat(values.value || "0"),
                                          );
                                        }
                                      }}
                                    />
                                    {isAmountExceeded && (
                                      <small className="text-danger d-block mt-1">
                                        Exceeds max ({maxAmount.toFixed(4)})
                                      </small>
                                    )}
                                  </div>
                                </Col>

                                <Col>
                                  <div className="form-group">
                                    <NumberFormat
                                      value={ele?.nav || "0"}
                                      className={`form-control ${
                                        errors[`fund_nav:${fundIndex}`]
                                          ? "border-danger text-danger"
                                          : ""
                                      }`}
                                      disabled
                                      decimalScale={4}
                                      allowNegative={false}
                                      placeholder="NAV"
                                    />
                                    {errors[`fund_nav:${fundIndex}`] && (
                                      <small className="text-danger">
                                        {errors[`fund_nav:${fundIndex}`]}
                                      </small>
                                    )}
                                  </div>
                                </Col>

                                {/* UNITS COLUMN — editable in withdrawal mode */}
                                <Col>
                                  <div className="form-group">
                                    <NumberFormat
                                      thousandSeparator={true}
                                      value={ele?.units || "0.0000"}
                                      // Editable only in withdrawal mode
                                      disabled={viewMode !== "withdrawal"}
                                      className={`form-control ${
                                        isWithdrawalExceeded
                                          ? "border-danger text-danger"
                                          : viewMode === "withdrawal"
                                            ? "border-primary"
                                            : ""
                                      }`}
                                      decimalScale={4}
                                      allowNegative={false}
                                      onValueChange={(values) => {
                                        if (viewMode === "withdrawal") {
                                          handleManualWithdrawalUnits(
                                            block.id,
                                            fundIndex,
                                            parseFloat(values.value || "0"),
                                          );
                                        }
                                      }}
                                    />
                                    {isWithdrawalExceeded && (
                                      <small className="text-danger d-block mt-1">
                                        Exceeds holding ({ele?.holding})
                                      </small>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            );
                          })}
                        </>
                      )}

                      {navLoading && (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <i
                            className="fa fa-spinner fa-spin"
                            style={{ fontSize: "24px", color: "#007bff" }}
                          ></i>
                          <div>Loading NAV data...</div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </CardBody>
            </Card>
          </Col>
        ) : null}
      </Row>
    </>
  );
}
